import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // connect() {
  //   console.log("menu-collapse connect to ", this.element)
  // }
  navigate(event) {
    appropo.log("navigate", event);
    event.preventDefault();

    const elem = document.getElementById('open-menu');
    new bootstrap.Collapse(elem, {
      hide: true
    })

    // need to delay until close menu animation finishes, otherwise the offset is wrong
    setTimeout(function() {
      location.hash = event.target.hash;
      Turbolinks.controller.pushHistoryWithLocationAndRestorationIdentifier(
        location.url,
        Turbolinks.uuid()
      )
    }, 350);
  }
}
